// extracted by mini-css-extract-plugin
export default {"borderVertical":"use-table-borders_borderVertical__4RF8z","borderHorizontal":"use-table-borders_borderHorizontal__776kc"};